var moduleMap = {
	"./Shell": () => {
		return Promise.all([__webpack_require__.e(6194), __webpack_require__.e(1234), __webpack_require__.e(6430), __webpack_require__.e(1869), __webpack_require__.e(4072), __webpack_require__.e(8018), __webpack_require__.e(9022), __webpack_require__.e(1137), __webpack_require__.e(1085), __webpack_require__.e(2325), __webpack_require__.e(4411), __webpack_require__.e(8782), __webpack_require__.e(7838), __webpack_require__.e(1177), __webpack_require__.e(6790), __webpack_require__.e(6496), __webpack_require__.e(9303), __webpack_require__.e(1783), __webpack_require__.e(7613), __webpack_require__.e(8406), __webpack_require__.e(5073), __webpack_require__.e(6015), __webpack_require__.e(4570)]).then(() => (() => ((__webpack_require__(94570)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});